import { render, staticRenderFns } from "./IconArrowDownOutline.vue?vue&type=template&id=06edcb3c"
import script from "./IconArrowDownOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowDownOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports